// Export the getters object
export default {
  /**
   * Return the query
   *
   * @param {Object} state
   * @returns {Object}
   */
  query(state) {
    return state.query
  },

  /**
   * Return the response
   *
   * @param {Object} state
   * @returns {Object}
   */
  response(state) {
    return state.response
  },

  /**
   * Return the selected platform
   *
   * @param {Object} state
   * @returns {String}
   */
  selectedPlatform(state) {
    return state.selectedPlatform
  },

  /**
   * Return the selected influencer
   *
   * @param {Object} state
   * @returns {String|Object|Null}
   */
  selectedInfluencer(state) {
    return state.selectedInfluencer
  },
}
